export default {
  empresaClientesAtivos: (state) => state.clientesAtivos && state.clientesAtivos['NUM_CLIENTES_ATIVOS'],
  empresaClientesFidelidade: (state) => state.clientesFidelidade && state.clientesFidelidade['NUM_CLIENTES_CADASTRADOS'],
  empresaClientesFora: (state) => state.clientesFora && state.clientesFora['NUM_CLIENTES_CADASTRADOS'],
  empresaClientesTotal: (state) => state.clientesTotal && state.clientesTotal['NUM_CLIENTES_CADASTRADOS'],
  empresaCupons: (state) => state.cupons && state.cupons['NUM_CUPONS'],
  empresaCuponsUltimos: (state) => state.cuponsUltimos && state.cuponsUltimos['NUM_CUPONS'],
  empresaFaturamento: (state) => state.faturamento && state.faturamento['VAL_FATURAMENTO'],
  empresaInicioFidelidade: (state) => state.inicioFidelidade && state.inicioFidelidade['DAT_INICIO_FIDELIDADE'],
  empresaItens: (state) => state.itens && state.itens['NUM_ITENS'],
  empresaPrimeiroRegistro: (state) => state.primeiroRegistro && state.primeiroRegistro['DAT_DATA_PRIMEIRO_REGISTRO'],
  // empresaUltimoRegistro: (state) => state.ultimoRegistro && state.ultimoRegistro['DAT_DATA_ULTIMO_REGISTRO'],
}
